import * as Sentry from '@sentry/react';
import { useTracking } from 'shared/providers/TrackingProvider';
import { useToast } from '@televet/kibble-ui/build/components/Toast';
import { FullMessageTemplateFragment, useArchiveMessageTemplateMutation } from 'shared/types/graphql';
import { MessageTemplateEvents } from 'shared/providers/TrackingProvider/EventNames';

const useArchiveMessageTemplate = (): {
  archiveMessageTemplate: (m: FullMessageTemplateFragment) => void;
  isLoading: boolean;
} => {
  const [mutate, { loading }] = useArchiveMessageTemplateMutation();
  const { trackEvent } = useTracking();
  const toast = useToast();

  const archiveMessageTemplate = async (messageTemplate: FullMessageTemplateFragment): Promise<void> => {
    if (!messageTemplate.id) return;

    const isArchiving = !messageTemplate?.isArchived;
    try {
      await mutate({
        variables: { messageTemplateId: messageTemplate.id, isArchived: isArchiving },
      });

      const eventName = isArchiving ? MessageTemplateEvents.TemplateArchived : MessageTemplateEvents.TemplateUnarchived;
      trackEvent(eventName);
    } catch (error) {
      console.error(error);
      Sentry.captureException(error);
      toast({
        status: 'error',
        title: `Whoops! An error occurred while ${
          isArchiving ? 'archiving' : 'unarchiving'
        } that message template. Please try again.`,
      });
    }
  };

  return { archiveMessageTemplate, isLoading: loading };
};

export default useArchiveMessageTemplate;
